/* eslint-disable vue/no-side-effects-in-computed-properties */
<template>
  <div class="topic-edit">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="small">
      <div class="white-container">
        <el-form-item label="课程标题" prop="title" style="width: 460px">
          <el-input v-model="form.title" placeholder="请输入课程标题" :disabled="disabledStatus" />
        </el-form-item>
        <el-form-item label="课程类型" prop="courseTypeId" style="width: 300px">
          <el-select v-model="form.courseTypeId" placeholder="请选择课程类型" :disabled="disabledStatus">
            <el-option v-for="item in courseType" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="跟练课类型" prop="isWithPractice" style="width: 500px; white-space: nowrap">
          <div class="form-radio">
            <el-radio v-model="form.isWithPractice" :label="0">非跟练课</el-radio>
            <el-radio v-model="form.isWithPractice" :label="1">跟练课</el-radio>
          </div>
        </el-form-item>
        <el-form-item label="UA品牌标识">
          <div class="coupon-upload">
            <div v-if="form.brandLogo" class="coupon_tip download-file">{{ form.brandLogo }}</div>
            <el-upload ref="uploader" class="xls-uploader" action="" accept="image/*" :show-file-list="false" :on-change="upLoadLogoUa" :auto-upload="false" :disabled="disabledStatus">
              <el-button v-if="form.brandLogo" size="small" type="primary">重新上传</el-button>
              <el-button v-else size="small" type="primary">上传标识</el-button>
            </el-upload>
            <div v-if="!form.brandLogo" class="coupon_tip upload_tips">支持上传*.png、 *.jpg、 *.jpeg、 *.svg格式</div>
          </div>
        </el-form-item>
        <el-form-item label="合作品牌标识">
          <div class="coupon-upload">
            <div v-if="form.subBrand" class="coupon_tip download-file">
              {{ form.subBrand }}
            </div>
            <el-upload ref="uploader" class="xls-uploader" action="" accept="image/*" :show-file-list="false" :on-change="upLoadLogoSub" :auto-upload="false" :disabled="disabledStatus">
              <el-button v-if="form.subBrand" size="small" type="primary">重新上传</el-button>
              <el-button v-else size="small" type="primary">上传标识</el-button>
            </el-upload>
            <div v-if="!form.subBrand" class="coupon_tip upload_tips">支持上传*.png、 *.jpg、 *.jpeg、 *.svg格式</div>
          </div>
        </el-form-item>
        <el-form-item label="课程教练" prop="coachSelectVO" style="width: 100%">
          <CoachSelect v-model="form.coachSelectVO" :value.sync="form.coachSelectVO" />
        </el-form-item>
        <el-form-item label="课程标签" prop="tags" style="width: 100%">
          <div class="flex">
            <el-select v-model="selectTagIndex" :disabled="disabledStatus" placeholder="请选择分类" style="margin-right: 20px">
              <el-option v-for="(item, index) in courseTags" :key="item.categoryId" :label="item.categoryName" :value="index" />
            </el-select>
            <el-select v-if="courseTags[selectTagIndex]" :key="courseTags[selectTagIndex].categoryId" v-model="courseTags[selectTagIndex].selectIds" :disabled="disabledStatus" :multiple="courseTags[selectTagIndex].multipleChoice" placeholder="请选择标签">
              <el-option v-for="item in courseTags[selectTagIndex].children" :key="item.id" :label="item.tagName" :value="item.id" />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="课程介绍" prop="description" style="width: 100%">
          <el-input v-model="form.description" type="textarea" placeholder="请输入活动介绍" :disabled="disabledStatus" />
        </el-form-item>
        <el-form-item label="视频课程文件" prop="mediaLink">
          <div class="coupon-upload">
            <el-upload ref="uploader" class="xls-uploader" action="" accept="video/*" :show-file-list="false" :on-change="upLoadVideo" :auto-upload="false" :disabled="disabledStatus">
              <el-button v-if="form.mediaLink" size="small" type="primary">重新上传</el-button>
              <el-button v-else size="small" type="primary">上传文件</el-button>
            </el-upload>
            <el-progress v-if="
              uploadProgress != 0 &&
                uploadProgress != 100 &&
                uploadProgressStatus
            " class="progress-cont" :text-inside="true" :stroke-width="16" :percentage="uploadProgress" />
            <div v-if="!form.mediaLink" class="coupon_tip upload_tips">
              仅支持上传*.mov、*.mp4格式
            </div>
            <div v-if="form.mediaLink" class="coupon_tip download-file">
              <video id="player-container" ref="customVideo" :src="form.mediaLink" class="custom-video" preload="auto" controls playsinline webkit-playsinline />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="课程卡路里" prop="totalConsumption">
          <el-input v-model.number="form.lowConsumption" :disabled="disabledStatus" placeholder="最低消耗" style="width: 100px; margin-right: 5px" @change="handleCheckKaLuLi" />
          <span>~</span>
          <el-input v-model.number="form.upConsumption" :disabled="disabledStatus" placeholder="最高消耗" style="width: 100px; margin-right: 5px" @change="handleCheckKaLuLi" />
          <label>千卡</label>
        </el-form-item>
        <el-form-item label="课程时长" prop="duration">
          <el-input v-model="form.duration" :disabled="disabledStatus" placeholder="课程时长" style="width: 100px; margin-right: 5px" />
          <label>分钟</label>
        </el-form-item>
        <el-form-item label="是否在列表页展示" prop="isShow" style="width: 500px; white-space: nowrap">
          <div class="form-radio">
            <el-radio v-model="form.isShow" :label="1">是</el-radio>
            <el-radio v-model="form.isShow" :label="0">否</el-radio>
          </div>
        </el-form-item>

      </div>
      <div class="white-container white-container-bottom marginTop">
        <el-form-item label="上传图片" prop="coverImage" class="image-config">
          <div class="flex uploadImg-cont">
            <UploadImage :disabled="disabledStatus" :url="form.coverImage.courseListPagePictureV2" save-path="course/" title="课程列表页图片" size-tips="360px*576px" @triggerReg="handleCheckReg" @upload="data => (form.coverImage.courseListPagePictureV2 = data)" />
            <UploadImage :disabled="disabledStatus" :url="form.coverImage.courseDetailsPageHeader" save-path="course/" title="课程详情页头图" size-tips="1125px*1125px" @triggerReg="handleCheckReg" @upload="data => (form.coverImage.courseDetailsPageHeader = data)" />
            <UploadImage :disabled="disabledStatus" :url="form.coverImage.recommendedPicturesOfHomeCourseV2" save-path="course/" title="首页课程推荐图片" size-tips="491px*660px" @triggerReg="handleCheckReg" @upload="data => (form.coverImage.recommendedPicturesOfHomeCourseV2 = data)" />
            <UploadImage :disabled="disabledStatus" :url="form.coverImage.recommendedPicturesOfRelevantCourse" save-path="course/" title="相关课程推荐图片" size-tips="491px*491px" @triggerReg="handleCheckReg" @upload="data =>(form.coverImage.recommendedPicturesOfRelevantCourse = data)" />

            <!-- <UploadImage :disabled="disabledStatus" :url="form.coverImage.courseRecommendedPicturesOnTheEvaluationReportPage" save-path="course/" title="评估报告页课程推荐图片" @upload="(data) => form.coverImage.courseRecommendedPicturesOnTheEvaluationReportPage = data" size-tips="360px*174px" /> -->
            <!-- <UploadImage :disabled="disabledStatus" :url="form.coverImage.myCourseListPictures" save-path="course/" title="我的课程列表页图片" size-tips="162px*180px" @triggerReg="handleCheckReg" @upload="data => (form.coverImage.myCourseListPictures = data)" /> -->
            <UploadImage :disabled="disabledStatus" :url="form.coverImage.shareCardImage" save-path="course/" title="小程序分享卡片" size-tips="500px*400px" :limit-size="2" @triggerReg="handleCheckReg" @upload="data => (form.coverImage.shareCardImage = data)" />
            <UploadImage :disabled="disabledStatus" :url="form.coverImage.shareImage" save-path="course/" title="课程长图分享图片" size-tips="849px*849px" @triggerReg="handleCheckReg" @upload="data => (form.coverImage.shareImage = data)" />

          </div>
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <el-form-item label="课程动作list配置" prop="action" class="product-config">
          <ActionList :disabled="disabledStatus" :lists="form.action" save-path="course/" @updateLists="updateLists" />
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <el-form-item label="关联商品配置" prop="recommendEquipments" class="product-config hide-required">
          <Product :disabled="disabledStatus" :products="form.recommendEquipments" save-path="course/" @updateProducts="updateProducts" />
        </el-form-item>
        <el-form-item style="width: 100%; margin-top: 80px; margin-left: -50px">
          <div class="flex btns">
            <el-button type="info" @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="submit">保存</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>
<script>
// import { mapActions, mapState } from 'vuex'
import { Class } from "@/model/Class";
import { getFileType } from "@/common/js/util";
import FunctionUtils from "@/utils/functionUtils";
import Product from "@/components/Product";
import ActionList from "@/components/ActionList";
import UploadImage from "@/components/UploadImage";
import Dialog from "@/components/Dialog";
import TcAdapter from "tcadapter";
import CoachSelect from "./select.vue";

export default {
  components: { Product, ActionList, UploadImage, Dialog, CoachSelect },

  data() {
    const checkCoachSelectVO = (rule, value, callback) => {
      if (!value.length) {
        callback(new Error('请选择课程教练'));
      } else {
        value.forEach(item => {
          if (item.level === '') {
            callback(new Error('请选择教练级别'));
          } else if (item.id === '') {
            callback(new Error('请选择课程教练'));
          } else if (value.filter(i => i.id === item.id).length > 1) {
            callback(new Error('请选择不重复的课程教练'));
          } else if (this.$store.state.activity.coachSelectVO.length && this.$store.state.activity.coachSelectVO.findIndex(it => it.id === item.id) === -1) {
            callback(new Error('请选择存在的课程教练'));
          }
        });
      }
      callback();
    };
    return {
      values: [],
      formDialogShow: false,
      information: {},
      cancelTxt: "",
      form: new Class(),
      courseType: [], // 课程类型
      courseTags: [], // 课程标签
      requiredTagId: [], // 标签必填ID
      selectTagIndex: 0,
      uploadProgress: 0, // 视频上传的进度
      uploadProgressStatus: false,
      disabledStatus: false,
      rules: {
        title: [
          { required: true, message: "请输入课程标题", trigger: ["blur"] },
        ],
        courseTypeId: [
          { required: true, message: "请选择课程类型", trigger: ["blur"] },
        ],
        isWithPractice: [
          { required: true, message: "请选择是否非跟练课", trigger: ["blur"] },
        ],
        coachSelectVO: [
          { required: true, message: "请选择课程教练", trigger: ["blur"] },
          { validator: checkCoachSelectVO, trigger: 'change' },
        ],
        tags: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请选择标签"));
              }
              const array = [];
              Array.isArray(value) &&
                value.forEach(item => {
                  if (
                    this.requiredTagId.includes(item.categoryId) &&
                    item.children.length === 0
                  ) {
                    array.push(item.categoryName);
                  }
                });
              if (array.length) {
                callback(new Error(`请选择${array.join("，")}`));
              } else {
                callback();
              }
            },
            trigger: ["blur"],
          },
        ],
        totalConsumption: [
          {
            required: false,
            validator: (rule, value, callback) => {
              const low = this.form.lowConsumption;
              const up = this.form.upConsumption;
              if (low !== '' && up !== '') {
                if (!/^[0-9]*[1-9][0-9]*$/.test(low) || !/^[0-9]*[1-9][0-9]*$/.test(up)) {
                  callback(new Error('请输入正整数'));
                } else if (Number(up) < Number(low)) {
                  callback(new Error('最高消耗必须大于最低消耗'));
                } else {
                  callback();
                }
              } else if (low && !up) {
                callback(new Error('请输入最高消耗'));
              } else if (!low && up) {
                callback(new Error('请输入最低消耗'));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        description: [
          { required: true, message: "请输入课程介绍", trigger: ["blur"] },
        ],
        mediaLink: [
          { required: true, message: "请上传课程视频文件", trigger: ["blur"] },
        ],
        duration: [
          { required: true, message: "请输入课程时长", trigger: ["blur"] },
        ],
        coverImage: {
          required: true, validator: (rule, value, callback) => {
            const keys = [
              { key: 'courseListPagePictureV2', label: '课程列表页图片' },
              { key: 'courseDetailsPageHeader', label: '课程详情页头图' },
              { key: 'recommendedPicturesOfHomeCourseV2', label: '首页课程推荐图片' },
              { key: 'recommendedPicturesOfRelevantCourse', label: '相关课程推荐图片' },
              { key: 'shareCardImage', label: '小程序分享卡片' },
              { key: 'shareImage', label: '课程长图分享图片' },
              // { key: 'courseRecommendedPicturesOnTheEvaluationReportPage', label: '评估报告页课程推荐图片' },
              // { key: 'myCourseListPictures', label: '我的课程列表页图片' },
            ];
            // value.recommendedPicturesOfHomeCourse = ' ';
            value.courseRecommendedPicturesOnTheEvaluationReportPage = ' ';
            value.myCourseListPictures = ' ';

            for (const { key, label } of keys) {
              if (!value[key]) {
                callback(new Error(`请上传${label}`));
              }
            }
            callback();
          }, trigger: ['change'],
        },

        action: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const contrastTime = value.find(
                item =>
                  parseInt(
                    FunctionUtils.timeToSec(item.actionPosition) / 1000,
                  ) > parseInt(parseFloat(this.form.duration) * 60),
              );
              if (!this.form.duration) {
                callback(new Error("请先上传视频再添加动作"));
              } else if (value.length === 0) {
                callback(new Error("请添加课程动作"));
              } else if (
                !value.every(
                  item => item.name && item.actionPosition && item.image,
                )
              ) {
                callback(new Error("请填写完整课程动作"));
              } else if (contrastTime) {
                callback(
                  new Error(
                    `${contrastTime.name}动作list开始时间超过视频总时长`,
                  ),
                );
              } else {
                callback();
              }
            },
            trigger: ["blur"],
          },
        ],
        recommendEquipments: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                value.length &&
                !value.every(item => item.name && item.imageUrl && item.linkTo)
              ) {
                callback(new Error("请填写完整相关商品配置"));
              } else {
                callback();
              }
            },
            trigger: ["blur"],
          },
        ],
      },
    };
  },
  computed: {
    // 教练数据重组，按等级区分教练人员
    // coachSelectVO() {
    //   const coachSelect = this.$store.state.activity.coachSelectVO.reduce(
    //     (init, item) => {
    //       // 没有等级，不添加
    //       if (!item.level) return init;
    //       const initItem =
    //             init.length > 0 ? init.find(it => it.level === item.level) : null;
    //       item.fullName = item.firstName + item.lastName;
    //       if (initItem) {
    //         const index = init.findIndex(it => it.level === initItem.level);
    //         init[index].personnel.push(item);
    //       } else {
    //         init.push({
    //           level: item.level,
    //           personnel: [{ ...item }],
    //         });
    //       }
    //       return init;
    //     },
    //     [],
    //   );
    //   // 默认第一个级别
    //   if (this.form.coachSelectVO.level === "" && coachSelect.length > 0) {
    //     // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    //     this.form.coachSelectVO.level = coachSelect[0].level;
    //   }
    //   return coachSelect;
    // },
    // 选中教练级别的下标
    coachSelectIndex() {
      const level = this.form.coachSelectVO.level
        ? this.form.coachSelectVO.level
        : "";
      return this.coachSelectVO
        ? this.coachSelectVO.findIndex(item => item.level === level) || 0
        : 0;
    },
  },
  watch: {
    courseTags: {
      handler(val) {
        const params = val.reduce((init, item) => {
          const select = {
            categoryId: item.categoryId,
            categoryName: item.categoryName,
            children: item.children.reduce((it, itx) => {
              if (
                Array.isArray(item.selectIds) &&
                item.selectIds.length &&
                item.selectIds.includes(itx.id)
              ) {
                it.push({
                  categoryId: itx.categoryId,
                  id: itx.id,
                  tagName: itx.tagName,
                });
              } else if (item.selectIds && item.selectIds === itx.id) {
                it.push({
                  categoryId: itx.categoryId,
                  id: itx.id,
                  tagName: itx.tagName,
                });
              }
              return it;
            }, []),
          };
          init.push(select);
          return init;
        }, []);
        this.form.tags = params.length > 0 ? params : "";
      },
      immediate: true,
      deep: true,
    },
    // "form.coachSelectVO.level": {
    //   handler(val, old) {
    //     // 自动获取视频时间长度
    //     this.$nextTick(() => {
    //       if (val !== old) this.form.coachSelectVO.id = "";
    //     });
    //   },
    //   deep: true,
    // },
    "form.mediaLink": {
      handler(val) {
        // 自动获取视频时间长度
        this.$nextTick(() => {
          const that = this;
          const customVideo = this.$refs["customVideo"];
          const eventListener = customVideo.addEventListener(
            "loadedmetadata",
            function () {
              that.form.duration = parseFloat(
                customVideo.duration / 60,
              ).toFixed(2);
              // const numHead = parseInt(customVideo.duration / 60), // 时长头两位
              //   numLast = parseInt((customVideo.duration / 60 - numHead) * 60), // 时长后两位
              //   fmtNum = numLast < 10 ? '0' + numLast : numLast;
              // that.form.duration = parseFloat(numHead + '.' + fmtNum).toFixed(2);
              customVideo.removeEventListener("loadedmetadata", eventListener);
            },
          );
        });
      },
      deep: true,
    },
  },
  async created() {
    await this.getCourseTypeList();
    await this.postCourseTag();
  },
  mounted() {
    const { query } = this.$route;
    if (query.id) {
      this.form.id = query.id;
      this.cancelTxt = "编辑";
      this.getCourseDetails("edit");
    } else if (query.copyid) {
      this.form.id = query.copyid;
      this.cancelTxt = "复制";
      this.getCourseDetails("copy");
    } else {
      console.info("新增");
      this.cancelTxt = "新增";
    }
  },
  methods: {
    handleCheckKaLuLi() {
      if (this.form.lowConsumption && this.form.upConsumption) {
        this.form.totalConsumption = `${this.form.lowConsumption}~${this.form.upConsumption}千卡`;
      } else if (!this.form.lowConsumption && !this.form.upConsumption) {
        this.form.totalConsumption = '';
      }
    },
    handleCheckReg(val) {
      this.$refs.form.validateField("coverImage");
    },
    // 获取课程类别
    getCourseTypeList() {
      this.$Api.course.getCourseTypeList().then(res => {
        this.courseType = res;
      });
    },
    // 课程标签列表
    postCourseTag() {
      this.$Api.course.postCourseTag().then(res => {
        const requiredTagId = [];
        this.courseTags = res.map(item => {
          if (item.required) requiredTagId.push(item.categoryId);
          if (item.multipleChoice) {
            item.selectIds = [];
          } else {
            item.selectIds = "";
          }
          return item;
        });
        this.requiredTagId = requiredTagId;
      });
    },
    // 获取课程详情
    async getCourseDetails(type) {
      const _this = this;
      await this.$Api.course.getCourseDetails(this.form.id).then(res => {
        if (!res.coachSelectVO.length || res.coachSelectVO[0].id === "") {
          res.coachSelectVO = [{
            id: "",
            level: "",
            firstName: "",
            lastName: "",
          }];
        }
        if (res.action) {
          res.action = res.action.map((item, index) => {
            item.order = index + 1;
            item.actionPosition = FunctionUtils.secTotime(item.actionPosition);
            return item;
          });
        }
        if (res.totalConsumption) {
          res.lowConsumption = res.totalConsumption.split('~')[0] || "";
          res.upConsumption = res.totalConsumption.split('~')[1].replace('千卡', '') || "";
        } else {
          res.lowConsumption = "";
          res.upConsumption = "";
        }
        if (res.tags) {
          this.courseTags.forEach(async item => {
            const findItem = await res.tags.find(
              it => item.categoryId === it.categoryId,
            );
            if (findItem) {
              item.selectIds = findItem.multipleChoice
                ? findItem.children.reduce((init, itx) => {
                  init.push(itx.id);
                  return init;
                }, [])
                : findItem.children[0].id;
            }
          });
        }
        _this.form = Object.assign(_this.form, res);
        // 开放编辑状态
        // if (this.form.status === 0 && type === "edit") this.disabledStatus = true;
        if (type === "copy") delete this.form.id;
      });
    },
    submit() {
      this.formDialogShow = true;
      this.information = {
        operation: "submit",
        icon: "warn",
        subTitle: "请注意课程状态，保存后已发布的课程信息将实时更新至UA HOUSE小程序",
      };
    },
    // 处理数据
    dealParams(params) {
      params.action = params.action.map(item => {
        item.actionPosition = parseInt(
          FunctionUtils.timeToSec(item.actionPosition) / 1000,
        );
        return item;
      });
      params.duration = parseInt(parseFloat(params.duration) * 60);
      params.coachSelects = [];
      params.coachSelectVO.forEach(item => {
        item.id && params.coachSelects.push(item.id);
      });
      return params;
    },
    // 新增课程
    putAddCourse() {
      const params = this.dealParams(Object.assign(this.form));
      this.$Api.course.putAddCourse(params).then(() => {
        this.$message.success("保存成功");
        this.$router.go(-1);
      }).catch(err => {
        this.$message.error(err.errorMessage || '保存失败');
        this.$router.go(-1);
        console.log(err, '新增课程');
      });
    },
    // 更新接口
    postUpdateCourse() {
      const params = this.dealParams(Object.assign(this.form));
      this.$Api.course.postUpdateCourse(params).then(() => {
        this.$message.success("编辑成功");
        this.$router.go(-1);
      }).catch(err => {
        this.$message.error(err.errorMessage || '保存失败');
        this.$router.go(-1);
        console.log(err, '更新接口');
      });
    },
    // 上传UA品牌标识
    upLoadLogoUa(file) {
      const type = getFileType(file.name, 'logo');
      if (type !== "image") {
        this.$message.error("仅支持上传png、 jpg、 jpeg、 svg格式");
        return false;
      }
      this.$Api.uploadFile.uploadImage(file.raw, "course/").then(res => {
        this.form.brandLogo = res;
      });
    },
    // 上传合作品牌标识
    upLoadLogoSub(file) {
      const type = getFileType(file.name, 'logo');
      if (type !== "image") {
        this.$message.error("仅支持上传png、 jpg、 jpeg、 svg格式");
        return false;
      }
      this.$Api.uploadFile.uploadImage(file.raw, "course/").then(res => {
        this.form.subBrand = res;
      });
    },
    // 上传视频
    upLoadVideo(file) {
      const type = getFileType(file.name);
      if (type !== "video") {
        this.$message.error("仅支持上传*.mov,*.mp4格式");
        return false;
      }
      this.uploadProgressStatus = true;
      this.$Api.uploadFile.putCloudDemandUpload({
        mediaFile: file.raw,
        onUploadProgress: progressEvent => {
          const process =
            parseInt((progressEvent.loaded / progressEvent.total) * 100) || 0;
          this.uploadProgress = process;
        },
      }).then(res => {
        this.form.fileId = res.fileId;
        this.form.mediaLink = res.mediaUrl;
        this.form.mediaSize = res.videoDuration || '0 MB';
        this.uploadProgressStatus = false;
        // this.$nextTick(() => {
        //   this.initTcAdapter(res)
        // })
      }).catch(_ => {
        this.uploadProgress = 0;
        this.uploadProgressStatus = false;
        this.$message.error("上传失败！");
      });
    },
    initTcAdapter(res) {
      if (!TcAdapter.isSupported()) {
        throw new Error("current environment can not support TcAdapter");
      }
      const appID = process.env.VUE_APP_TC_APPID;
      let adapter = new TcAdapter(
        document.getElementById("player-container"),
        {
          appID: appID,
          fileID: res.fileID,
        },
        () => {
          this.form.fileId = res.fileId;
          this.form.duration = parseFloat(
            adapter.basicInfo.duration / 60,
          ).toFixed(2);
          this.form.mediaLink = res.mediaUrl;
          this.form.mediaSize = `${parseFloat(
            adapter.basicInfo.size / 1024,
          ).toFixed(2)} M`;
        },
      );
      const setTime = setTimeout(() => {
        if (adapter.getVideoBasicInfo().name) {
          clearTimeout(setTime);
          return;
        }
        adapter = null;
        this.initTcAdapter(res);
      }, 5000);
    },
    updateProducts(products) {
      this.form.recommendEquipments = products;
    },
    updateLists(lists) {
      this.form.action = lists;
    },
    // 取消
    handleCancel() {
      this.formDialogShow = true;
      this.information = {
        operation: "cancel",
        icon: "warn",
        subTitle: `是否放弃${this.cancelTxt}，返回上级页面？`,
      };
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'cancel') {
        this.$router.go(-1);
      } else if (this.information.operation && this.information.operation === 'submit') {
        console.log(11111);
        this.$refs.form.validate(valid => {
          console.log(valid);
          if (valid) {
            if (this.form.id) {
              this.postUpdateCourse();
            } else {
              this.putAddCourse();
            }
          } else {
            return false;
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.btns {
  align-items: center;
  justify-content: center;
}

.marginTop {
  margin-top: 30px;
}
</style>
<style lang="less">
.topic-edit {
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
    .form-radio {
      line-height: 32px;
      height: 32px;
      align-items: center;
    }
  }
  .coach-select-box + .el-form-item__error {
    top: unset !important;
    bottom: 43px !important;
  }
  .form-icon {
    margin-left: 10px;
    .el-icon-close {
      color: #9b9b9b;
      cursor: pointer;
      &:hover {
        color: #000000;
      }
    }
  }
  .form-add {
    margin-top: 24px;
    .el-button {
      border: 1px dashed #bbbbbb;
      i {
        color: #bbbbbb;
      }
      span {
        color: #bbbbbb;
      }
    }
  }
  .product-config,
  .image-config {
    .el-form-item__label {
      float: none;
    }

    .el-form-item__content {
      margin-left: 0 !important;
    }

    &.hide-required {
      .el-form-item__label {
        &::before {
          display: none;
        }
      }
    }
  }
}

.custom-video {
  width: 331px;
  height: 190px;
}

.white-container-bottom {
  padding-bottom: 0;
}

.uploadImg-cont {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .uploader {
    margin-bottom: 30px;

    &:last-child {
      margin-right: 0;
    }
  }
}

.progress-cont {
  width: 300px;
  margin-top: 8px;
}
</style>
